import React from "react";
import "react-clock/dist/Clock.css";
import TimePicker from "react-time-picker";
import "react-time-picker/dist/TimePicker.css";

interface TimePicker12HrProps {
  value: string;
  onChange: (value: string | null) => void;
  className?: string;
  disabled?: boolean;
}

const ReactTimePicker: React.FC<TimePicker12HrProps> = ({
  value,
  onChange,
  className = "",
  disabled = false,
}) => (
  <TimePicker
    onChange={onChange}
    value={value}
    disableClock
    className={className}
    format="hh:mm a" // shows in 12-hour format
    clearIcon={null}
    clockIcon={null}
    disabled={disabled}
  />
);

export default ReactTimePicker;